import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#181a20',
      paper: '#181a20',
    },
    primary: {
      main: '#c9a74c',
    },
    secondary: {
      main: '#84b3e0',
    },
    accent: {
      main: '#2c4c7c',
    },
    menuHighlight: {
      main: '#ffd700',
    },
    text: {
      primary: '#c9a74c',
      secondary: '#bfae7a',
    },
  },
  typography: {
    fontFamily: 'Nunito, Montserrat, Segoe UI, Arial, sans-serif',
    h1: {
      fontWeight: 900,
      fontSize: '3rem',
      lineHeight: 1.1,
    },
    h2: {
      fontWeight: 700,
      fontSize: '2.25rem',
      lineHeight: 1.2,
    },
    h3: {
      fontWeight: 700,
      fontSize: '1.5rem',
      lineHeight: 1.3,
    },
    h4: {
      fontWeight: 700,
      fontSize: '1.25rem',
      lineHeight: 1.4,
    },
    h5: {
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    h6: {
      fontWeight: 600,
      fontSize: '0.875rem',
      lineHeight: 1.6,
    },
    body1: {
      fontSize: '1.1rem',
      lineHeight: 1.7,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          fontWeight: 700,
          textTransform: 'none',
          transition: 'all 0.3s',
          '&:hover': {
            backgroundColor: '#c9a74c',
            color: '#111216',
            boxShadow: '0 4px 20px rgba(201,167,76,0.15)',
            transform: 'translateY(-2px) scale(1.04)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 5px 15px rgba(0,0,0,0.08)',
          background: '#181a20',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: '#181a20',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          background: 'transparent',
        },
      },
    },
  },
});

export default theme; 